<template>
  <div class="login" style="height: 100%">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">
          {{ profile.user + $t("pro.info") }}
        </h2>
      </div>
      <div
        class="weui-form__control-area"
        style="
          max-width: 500px;
          display: block;
          margin-left: 0px;
          margin-right: auto;
        "
      >
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">Token:</label>
              </div>
              <div class="weui-cell__bd" style="color: #645f5f">
                {{ profile.token }}
              </div>
              <div class="weui-cell__bd" style="padding-left: 15px;">
              <a
                role="button"
                class="copy weui-swiped-btn weui-btn_primary"
                :data-clipboard-text="profile.token"
                @click="toClipboard"
                >{{ $t("copy") }}</a
              >
            </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("email") }}:</label>
              </div>
              <div class="weui-cell__bd" style="color: #f1ebeb">
                <input v-model="profile.email" class="weui-input" />
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("phone") }}:</label>
              </div>
              <div class="weui-cell__bd" style="color: #f1ebeb">
                <input v-model="profile.phone" class="weui-input" />
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("regTime") }}:</label>
              </div>
              <div class="weui-cell__bd" style="color: #645f5f">
                {{ profile.addtime }}
              </div>
            </div>
          </div>
        </div>
        <div class="weui-form__opr-area">
        <a
          class="weui-btn weui-btn_primary"
          v-on:click="save"
          href="javascript:"
          >{{ $t("save") }}</a
        >
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import weui from "weui.js"
import ClipboardJS from "clipboard"
export default {
  name: "profile",
  components: {},
  data() {
    return {
      clients: [],
      profile: {},
    }
  },

  beforeMount() {},

  mounted() {
    this.loadClients()
  },

  methods: {
    loadClients: async function () {
      let _this = this
      axios
        .post(this.$ServerHost + "/api/v1/user/profile")
        .then((response) => {
          window.debugLog(response)
          if (response.status == 200 && response.data.error == 0) {
            window.debugLog(response.data)
            this.profile = response.data.profile
          } else {
            weui.alert(_this.$t("pro.errReq"), {
              buttons: [
                {
                  label: _this.$t("ok"),
                },
              ],
            })
          }
        })
        .catch(function () {
          weui.alert(_this.$t("pro.errReq"), {
            buttons: [
              {
                label: _this.$t("ok"),
              },
            ],
          })
        })
    },
    toClipboard: function () {
      let _this = this
      let clipboard = new ClipboardJS(".copy") // mobile mode will failed.
      let clipboard2 = new ClipboardJS(".copy") // mobile mode will failed.
      let clipboard3 = new ClipboardJS(".copy") // mobile mode will failed.
      clipboard.on("success", () => {
        weui.toast(_this.$t("copyOK"), 1000)
        clipboard.destroy()
        clipboard2.destroy()
        clipboard3.destroy()
      })
      clipboard.on("error", () => {
        weui.toast(_this.$t("copyError"), 1000)
        clipboard.destroy()
      })
    },
    save() {
      let _this = this
      window.debugLog("save profile edit")
      axios
        .put(
          this.$ServerHost +
            "/api/v2/user/profile",
          {
            user: "666",
            token: "666",
            email: this.profile.email,
            phone: this.profile.phone,
          }
        )
        .then((response) => {
          window.debugLog(response)
          if (response.status == 200) {
            // update cache
            weui.alert(_this.$t("saveOK"), {
              buttons: [
                {
                  label: _this.$t("ok"),
                  onClick: function () {
                    _this.$router.go(-1)
                  },
                },
              ],
            })
          } else {
            window.debugLog("profile edit error:" + response)
          }
        })
        .catch(function (error) {
          weui.alert(_this.$t("saveError"), {
            buttons: [
              {
                label: _this.$t("ok"),
              },
            ],
          })
          window.debugLog(error)
        })
    },
  },

  watch: {},
}
</script>


<style lang="scss" scoped>
.weui-cells__group_form {
  .weui-label {
    max-width: 7em;
    
  }
  .weui-cell__hd {
    padding-right: 5px;
  }
  .weui-cell {
    padding: 16px;
  }
  .weui-swiped-btn.weui-btn_primary {
  padding: 5px 5px; /* 调整内边距 */
}
}
</style>